export default "__VITE_ASSET__CJm$P43f__"